import { addAutomation, deleteAutomation, editAutomation, fetchAutomationList, fetchExportData, getAutomationListCnt, getDartDetails } from './automation_common_func';

type SchedulerProps = {
  data: any;
  func: any;
  rowID: number;
  tenant: string;
  newData: any;
  saveBtnClicked: boolean;
  dartNo: number;
  setAutomationSearchData: any;
  setOverlayName: any;
  setSaveBtnClicked: any;
  setOverlayOpen: any;
  setErrorToast: any;
  setToastMessage: any;
  setIsToast: any;
  searchVal: String;
  pageNo: number;
  setTotalPages: any;
  setTotalRecords: any;
  setDartSpecs: any;
  setJsonData: any;
  setUiData: any;
  deleteAutomation: any;
  setDeleteAutomation: any;
  setDeleteDisabled: any;
  isRefresh: any;
  setRefresh: any;
  setIsRefresh?: any
  setRefreshToast?: any
  isFilter?: boolean;
  dropDownValue1?: string;
  setIsFilter?: any
  dropdownValue2?: string
  filterArray?: string[];
  overlayName: string;
  formData: any;
  setFormData: any;
  selectedRowIdInTable: any[];
  exportBtnClicked: boolean;
  setExportBtnClicked: any;
  setExportDetails: any;
  automationSearchVal: string;
  setSaveTriggered: any;
  dartSpecs: string[];
  setLoading?: any;
  setSpinnerLoad?: any;
}

const schedulerConfiguration = (props: SchedulerProps) => {
  const getAutomationList = async (whereCondition: any, limit: any = null, offset: any = null) => {
    try {
      const { data, status } = await fetchAutomationList(whereCondition, limit, offset);

      if (status === 'success' && data.length > 0) {
        if (props.overlayName === 'editAutomation') {
          props.setFormData({
            ...props.formData,
            name: data[0]?.automationName,
            description: data[0]?.description,
            jsonData: JSON.parse(data[0]?.jsonValue)
          });
          props?.setSpinnerLoad(false);
        } else {
          props.setLoading(true);
          props.func(data);
        }
      } else {
        props.func([]);
      }
    } catch (error) {
      console.log("getAutomationList error=", error);
      props.func([]);
    }
  };

  const getExportData = async (condition: object) => {
    const { data, status } = await fetchExportData(condition);

    if (status === 'success') {
      props.setExportDetails && props.setExportDetails(data);
    }
    props.setExportBtnClicked(false);
  }

  const deleteUnattachedAutomation = async (ids: number[]) => {
    try {
      const { data, status } = await deleteAutomation(ids, 'scheduler', props.tenant);

      if (status === 'success' && data.affected_rows > 0) {
        props.setDeleteDisabled(true);
        props.setDeleteAutomation(false);
        props.setIsToast(true);

        // getAutomationList({ types: 'scheduler' }, 50, props.pageNo);
        // getAutomationListCnt({ types: 'scheduler' }, props.setTotalRecords, props.setTotalPages);
      } else {
        props.setToastMessage(`Scheduler ${props.selectedRowIdInTable.length < 2 ? 'automation' : 'automations'} deletion failed`);
        props.setErrorToast(true);
      }
    } catch (error) {
      props.setToastMessage(`Scheduler ${props.selectedRowIdInTable.length < 2 ? 'automation' : 'automations'} deletion failed`);
      props.setErrorToast(true);
    }
  }

  const createAutomation = async (automationName: string, description: string, jsonVal: string, dartid: number, tenant: string) => {
    try {
      const { status } = await addAutomation(automationName, description, jsonVal, dartid, 'scheduler', tenant);

      if (status === 'success') {
        props.setOverlayOpen(false);
        props.setIsToast(true);

        setTimeout(() => {
          props.setSaveBtnClicked(false);
          props.setSaveTriggered(false);
        }, 2000);

        // getAutomationList({ types: 'scheduler' }, 50, props.pageNo);
        // getAutomationListCnt({ types: 'scheduler' }, props.setTotalRecords, props.setTotalPages);
      } else {
        props.setToastMessage(`${automationName} automation creation failed`);
        props.setErrorToast(true);
      }
    } catch (error) {
      console.log("createAutomation error=", error);
      props.setToastMessage(`${automationName} automation creation failed`);
      props.setErrorToast(true);
    }
  }

  const modifyAutomation = async (automationName: string, description: string, jsonVal: string, dartid: number, id: number, tenant: string) => {
    try {
      const { status } = await editAutomation(automationName, description, jsonVal, dartid, id, tenant, 'scheduler');

      if (status === 'success') {
        props.setOverlayOpen(false);
        props.setIsToast(true);

        setTimeout(() => {
          props.setSaveBtnClicked(false);
          props.setSaveTriggered(false);
        }, 1000);

        // getAutomationList({ types: 'scheduler' }, 50, props.pageNo);
      } else if (status === 'failed') {
        props.setToastMessage("This automation can't be edited as it is already configured");
        props.setErrorToast(true);
        props.setOverlayOpen(false);
        props.setOverlayName('');
        setTimeout(() => {
          props.setSaveBtnClicked(false);
        }, 1000);
      } else {
        props.setToastMessage(`Error occured while saving ${automationName} self-help automation`);
        props.setErrorToast(true);
        props.setOverlayOpen(false);
        props.setOverlayName('');
        setTimeout(() => {
          props.setSaveBtnClicked(false);
        }, 1000);
      }
    } catch (error) {
      console.log("modifyAutomation error=", error);

      props.setToastMessage(`Error occured while saving ${automationName} self-help automation`);
      props.setErrorToast(true);
      props.setOverlayOpen(false);
      setTimeout(() => {
        props.setSaveBtnClicked(false);
      }, 1000);
    }
  }

  const automationSearch = async (whereCondition: any, limit: number | null, offset: number | null) => {
    try {
      const { data, status } = await fetchAutomationList(whereCondition, limit, offset);

      if (status === 'success') {
        const automationArr: any = [];

        data.forEach(async (val: any) => {
          await automationArr.push(val.automationName);
        });

        props.setAutomationSearchData(automationArr);
      }
    } catch (error) {
      console.log("automationSearch error=", error);
    }
  }

  if (props.dartSpecs.length === 0) {
    getDartDetails(props.dartNo, props.setDartSpecs);
  } else if (props.isRefresh) {
    props.setRefresh(false);
    props.setRefreshToast(true);
    setTimeout(() => {
      props.setRefreshToast(false);
    }, 3000);
  }

  if (props.searchVal?.length > 0 && props.searchVal !== '' && props.overlayName === '') {
    getAutomationList({ search: props.searchVal, function: 'search', types: 'scheduler' }, 50, props.pageNo);
    getAutomationListCnt({ search: props.searchVal, function: 'search', types: 'scheduler' }, props.setTotalRecords, props.setTotalPages);
  } else if (props.isFilter === true) {
    const whereCondition = { "types": "scheduler", function: 'filter', filter: props.filterArray };

    getAutomationList(whereCondition, 50, props.pageNo);
    getAutomationListCnt(whereCondition, props.setTotalRecords, props.setTotalPages);
  } else if (props.deleteAutomation && props.selectedRowIdInTable.length > 0) {
    deleteUnattachedAutomation(props.selectedRowIdInTable);
  } else if (props.saveBtnClicked && props.newData !== undefined && Object.keys(props.newData).length > 0) {
    props.overlayName === 'addAutomation' && createAutomation(props.newData.name, props.newData.description, props.newData.jsonData, props.dartNo, props.tenant);

    props.overlayName === 'editAutomation' && modifyAutomation(props.newData.name, props.newData.description, props.newData.jsonData, props.dartNo, props.rowID, props.tenant);
  } else if (!(props.saveBtnClicked) && props.overlayName === 'editAutomation' && props.automationSearchVal?.length < 1) {
    getAutomationList({ dartid: props.dartNo, id: props.rowID, types: 'scheduler' }, 0, null);
  } else if (props.automationSearchVal?.length > 0 && props.automationSearchVal !== '') {
    automationSearch({ types: ['selfhelp', 'proactive'], dartid: 304, status: { contains: `${props.tenant}:` }, automationName: { contains: props.automationSearchVal } }, null, null);
  } else if (props.exportBtnClicked) {
    getExportData({ types: 'scheduler', function: 'export', tenant: props.tenant });
  } else {
    props.overlayName === '' && getAutomationList({ types: 'scheduler' }, 50, props.pageNo);

    props.overlayName === '' && getAutomationListCnt({ types: 'scheduler' }, props.setTotalRecords, props.setTotalPages);
  }
}

export { schedulerConfiguration }